import React, {
    useState
}
from "react";

import {
    useHistory
}
from "react-router-dom";

import MobileHeader
from "../../home/mobile/components/MobileHeader";

import AmChartSunburst
from "../../../components/AmChartSunburst";

import BlockStackBarList
from "../../../components/BlockStackBarList";

import AmChartTreemap
from "../../../components/AmChartTreemap";

import useSpaceOrgDashboard
from "../hooks/useSpaceOrgDashboard";

import "./MobileSpaceOrgDashboard.css";


export default function MobileSpaceOrgDashboard()
{
    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [showMenu, setShowMenu] =
        useState(false);


    //--------------------------------------------------------
    // Dashboard Data
    //--------------------------------------------------------

    const {
        kpis,
        spaceBreakdown,
        topBuildings
    } =
        useSpaceOrgDashboard();


    //--------------------------------------------------------
    // KPI Values
    //--------------------------------------------------------

    let area =
        0;

    let capacity =
        0;

    let spaces =
        0;

    let buildings =
        0;


    for(
        let i = 0;
        i < kpis.length;
        i++
    )
    {
        const kpi =
            kpis[i];

        switch(
            kpi.code
        )
        {
            case "AREA":

                area =
                    kpi.value;

                break;


            case "CAPACITY":

                capacity =
                    kpi.value;

                break;


            case "SPACES":

                spaces =
                    kpi.value;

                break;


            case "BUILDINGS":

                buildings =
                    kpi.value;

                break;


            default:

                break;
        }
    }


    //--------------------------------------------------------
    // Helpers
    //--------------------------------------------------------

    const hasSpaceBreakdown =
        spaceBreakdown &&
        spaceBreakdown.length > 0;


    //--------------------------------------------------------
    // Building Click
    //--------------------------------------------------------

    const handleBuildingClick =
        (id) =>
        {
            history.push(
                "/spaceorgbuilding/" +
                id
            );
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div className="mobile-space-dashboard-page">


            {/*--------------------------------------------------
                Mobile Header
            --------------------------------------------------*/}

            <MobileHeader

                openMenu={
                    () =>
                        setShowMenu(true)
                }

                openSearch={
                    () =>
                        console.log(
                            "SEARCH"
                        )
                }

            />


            {/*--------------------------------------------------
                Scrollable Page
            --------------------------------------------------*/}

            <div className="mobile-space-dashboard-content">


                {/*--------------------------------------------------
                    Heading
                --------------------------------------------------*/}

                <div className="mobile-space-dashboard-heading">

                    <div className="mobile-space-dashboard-title">

                        Space Dashboard

                    </div>

                    <div className="mobile-space-dashboard-subtitle">

                        Portfolio space, capacity and
                        building distribution.

                    </div>

                </div>


                {/*--------------------------------------------------
                    KPI Grid
                --------------------------------------------------*/}

                <div className="mobile-space-dashboard-kpis">


                    <div className="mobile-space-dashboard-kpi">

                        <div className="mobile-space-dashboard-kpi-value">

                            {
                                Number(
                                    area
                                )
                                .toLocaleString()
                            }

                        </div>

                        <div className="mobile-space-dashboard-kpi-label">

                            Total Area

                        </div>

                        <div className="mobile-space-dashboard-kpi-unit">

                            sqm

                        </div>

                    </div>


                    <div className="mobile-space-dashboard-kpi">

                        <div className="mobile-space-dashboard-kpi-value">

                            {
                                Number(
                                    capacity
                                )
                                .toLocaleString()
                            }

                        </div>

                        <div className="mobile-space-dashboard-kpi-label">

                            Capacity

                        </div>

                    </div>


                    <div className="mobile-space-dashboard-kpi">

                        <div className="mobile-space-dashboard-kpi-value">

                            {
                                Number(
                                    spaces
                                )
                                .toLocaleString()
                            }

                        </div>

                        <div className="mobile-space-dashboard-kpi-label">

                            Spaces

                        </div>

                    </div>


                    <div className="mobile-space-dashboard-kpi">

                        <div className="mobile-space-dashboard-kpi-value">

                            {
                                Number(
                                    buildings
                                )
                                .toLocaleString()
                            }

                        </div>

                        <div className="mobile-space-dashboard-kpi-label">

                            Buildings

                        </div>

                    </div>


                </div>


                {/*--------------------------------------------------
                    Space Distribution
                --------------------------------------------------*/}

                <div className="mobile-space-dashboard-card">

                    <div className="mobile-space-dashboard-card-heading">

                        <div className="mobile-space-dashboard-card-title">

                            Space Distribution

                        </div>

                        <div className="mobile-space-dashboard-card-subtitle">

                            Capacity by space type

                        </div>

                    </div>


                    <div className="mobile-space-dashboard-sunburst">

                        {
                            hasSpaceBreakdown &&
                            (
                                <AmChartSunburst

                                    key="mobile-space-sunburst"

                                    width="100%"

                                    height="330px"

                                    chartData={
                                        spaceBreakdown
                                    }

                                    chartId="mobilespaceorgdashboardsunburst"

                                    valueColumn="capacity"

                                    nameColumn="description"

                                    childrenColumn="children"

                                />
                            )
                        }

                    </div>

                </div>


                {/*--------------------------------------------------
                    Top Buildings
                --------------------------------------------------*/}

                <div className="mobile-space-dashboard-dark-card">

                    <div className="mobile-space-dashboard-dark-heading">

                        <div>

                            <div className="mobile-space-dashboard-dark-title">

                                Top Buildings

                            </div>

                            <div className="mobile-space-dashboard-dark-subtitle">

                                Largest buildings by portfolio space

                            </div>

                        </div>

                    </div>


                    <div className="mobile-space-dashboard-building-list">

                        <BlockStackBarList

                            title="Top Buildings"

                            rows={
                                topBuildings
                            }

                            onSelect={
                                handleBuildingClick
                            }

                        />

                    </div>

                </div>


				{/*--------------------------------------------------
				    Space Type Breakdown
				--------------------------------------------------*/}

				<div className="mobile-space-dashboard-dark-card">

				    <div className="mobile-space-dashboard-dark-heading">

				        <div>

				            <div className="mobile-space-dashboard-dark-title">

				                Space Type Breakdown

				            </div>

				            <div className="mobile-space-dashboard-dark-subtitle">

				                Relative capacity across the portfolio

				            </div>

				        </div>

				    </div>

				    <div className="mobile-space-dashboard-treemap">

				        {
				            hasSpaceBreakdown &&
				            (
				                <AmChartTreemap

				                    chartId="mobileSpaceDashboardTreemap"

				                    width="100%"

				                    height="300px"

				                    chartData={
				                        spaceBreakdown
				                    }

				                    valueColumn="capacity"

				                    nameColumn="description"

				                    childrenColumn="children"

				                    onClick={
				                        (item) =>
				                        {
				                            console.log(
				                                item
				                            );
				                        }
				                    }

				                />
				            )
				        }

				    </div>

				</div>


            </div>

        </div>

    );
}